// extracted by mini-css-extract-plugin
module.exports = {"label":"PageTitleWithLabel_label__VJMTl","isWhite":"PageTitleWithLabel_isWhite__Ags19","title":"PageTitleWithLabel_title__7HrNM"};